import React, { Component } from "react";
import { Card, Col, Container, Form, Row, Button } from "react-bootstrap";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import configData from "../config.json";
import "./PoliciesFormFillingPage.css";
import { Link } from "react-router-dom";
import "./PoliciesKYCForm.css";
import DatePicker from "react-datepicker";
import LoadingOverlay from "./LoadingOverlay";
import "react-datepicker/dist/react-datepicker.css";
import "bootstrap/dist/css/bootstrap.min.css";

// import { Link } from "react-router-dom";

export default class PoliciesKYCForm extends Component {
  constructor(props) {
    super(props);
    this.state = {
      loading: false,
      loadingMessage: "Processing your request...",
      chpiId: sessionStorage.getItem("chpiId"),
      proposalId: sessionStorage.getItem("proposalId"),
      proposalNum: sessionStorage.getItem("proposalNum"),
      baseproductId: sessionStorage.getItem("baseproductId"),
      cqrId: sessionStorage.getItem("cqrId"),
      uId: sessionStorage.getItem("uId"),
      policieskyc: [],
      idTYPE: "",
      idNum: "",
      dob: null,
      aadharno: "",
      gender: "",
      name: "",
      ovdType: "",
      filePath: "",
      consent_purpose: "this is a consent purpose string pass anything",
      jsonDisplay: null,
      errorMessage: "",
      showAadharForm: false,
      showUploadform: false,
      noPanCard: false,
      startDate: new Date(),
    };
  }
  showToast = (msg, type) => {
    var tType = toast.TYPE.INFO;
    if (type === "success") tType = toast.TYPE.SUCCESS;
    if (type === "error") tType = toast.TYPE.ERROR;
    if (type === "warning") tType = toast.TYPE.WARNING;
    toast(msg, { type: tType });
  };

  handleChange = (e) => {
    const { name, value } = e.target;
    const uppercaseValue = value.toUpperCase();

    this.setState({
      [name]: name === "idNum" ? uppercaseValue : value,
      errors: {
        ...this.state.errors,
        [name]: uppercaseValue,
      },
    });
  };
  handleaProofChange = (e) => {
    const file = e.target.files[0];
    // const newFormData = this.state.aProof;
    // newFormData["aProof"] = file;
    this.setState({ aProof: file });
  };
  handleDChange = (date) => {
    if (date) {
      const formattedDate = `${date.getFullYear()}-${(date.getMonth() + 1)
        .toString()
        .padStart(2, "0")}-${date.getDate().toString().padStart(2, "0")}`;
      console.log(date);
      console.log(formattedDate);
      // Assuming you want to update the 'dob' state with the selected date
      this.setState({
        dob: formattedDate,
        startDate: new Date(),
      });
    }
  };

  validateForm() {
    let policykyc = this.state;
    let errors = {};
    let formIsValid = true;
    if (!policykyc["idTYPE"]) {
      formIsValid = false;
      toast.info("*Please Enter Document Type.");
    } else if (!policykyc["idNum"]) {
      formIsValid = false;
      toast.info("*Please Enter PAN Number.");
    } else if (
      policykyc["idTYPE"] === "PAN" &&
      !/^[A-Z]{3}P[A-Z]{1}[0-9]{4}[A-Z]{1}$/.test(policykyc["idNum"])
    ) {
      // Check PAN validation only when idTYPE is "PAN"
      formIsValid = false;
      toast.info("*Invalid PAN Number format.");
    } else if (policykyc["idNum"].length !== 10) {
      // Check if PAN Number has exactly 10 characters
      formIsValid = false;
      toast.info("*PAN Number should be 10 characters long.");
    } else if (!policykyc["dob"]) {
      formIsValid = false;
      toast.info("*Please Enter Date of Birth.");
    }

    this.setState({
      errors: errors,
    });
    return formIsValid;
  }
  handleSubmitClick = (e) => {
    e.preventDefault();
    if (this.validateForm()) {
      var formData = new FormData();
      formData.append("chpiId", this.state.chpiId);
      formData.append("proposalId", this.state.proposalId);
      formData.append("idNum", this.state.idNum);
      formData.append("idTYPE", this.state.idTYPE);
      formData.append("dob", this.state.dob);
      formData.append("consent_purpose", this.state.consent_purpose);
      console.log(formData);
      fetch(configData.api_url + "leads/ckyc/", {
        // Enter your IP address here

        method: "POST",
        //headers :{ 'Content-Type' : 'application/json'},
        mode: "cors",
        body: formData, // body data type must match "Content-Type" header
      })
        .then((response) => response.json())
        .then((data) => {
          this.showToast(data.message, data.success);
          if (data.status === "success") {
            this.setState({
              dob: "",
              idTYPE: "",
              idNum: "",
              id_number: "",
            });
            this.handleButtonClick();
            // window.location.href = "/proposerinfo";
          } else {
            this.setState({ showAadharForm: true });
          }
          //this.createPolicy();
        });
    }
  };
  //Aadhar
  validateAadhaarForm() {
    let policykyc = this.state;
    let errors = {};
    let formIsValid = true;

    if (!policykyc["aadharno"]) {
      formIsValid = false;
      toast.info("*Please Enter Aadhaar Number.");
    } else if (policykyc["aadharno"].length !== 4) {
      // Check if PAN Number has exactly 10 characters
      formIsValid = false;
      toast.info("Adhar Number should be 4 characters long.");
    } else if (!policykyc["name"]) {
      formIsValid = false;
      toast.info("*Please Enter Name.");
    } else if (!policykyc["dob"]) {
      formIsValid = false;
      toast.info("*Please Enter Date of Birth.");
    } else if (!policykyc["gender"]) {
      formIsValid = false;
      toast.info("*Please Select Gender.");
    }

    this.setState({
      errors: errors,
    });
    return formIsValid;
  }
  handleAadhaarSubmitClick = (e) => {
    e.preventDefault();
    if (this.validateAadhaarForm()) {
      var formData = new FormData();
      formData.append("chpiId", this.state.chpiId);
      formData.append("proposalId", this.state.proposalId);
      formData.append("aadharno", this.state.aadharno);
      formData.append("idTYPE", this.state.idTYPE);
      formData.append("gender", this.state.gender);
      formData.append("name", this.state.name);
      formData.append("dob", this.state.dob);
      console.log(this.state.dob);
      console.log(this.state.aadharno);
      fetch(configData.api_url + "leads/akyc", {
        // Enter your IP address here

        method: "POST",
        //headers :{ 'Content-Type' : 'application/json'},
        mode: "cors",
        body: formData, // body data type must match "Content-Type" header
      })
        .then((response) => response.json())
        .then((data) => {
          this.showToast(data.message, data.success);
          if (data.status === "success") {
            this.handleButtonClick();
            this.setState({
              dob: "",
              idTYPE: "",
              aadharno: "",
              gender: "",
              name: "",
            });
            //window.location.href = "/proposerinfo";
          } else {
            this.setState({ showUploadform: true });
          }
        });
    }
  };
  //File Upload
  validateuploadpathForm() {
    let policykyc = this.state;
    let errors = {};
    let formIsValid = true;

    if (!policykyc["ovdType"]) {
      formIsValid = false;
      toast.info("*Please Select ovd Type .");
    } else if (!policykyc["filePath"]) {
      formIsValid = false;
      toast.info("*Please upload file.");
    }

    this.setState({
      errors: errors,
    });
    return formIsValid;
  }
  handleFileuploadSubmitClick = (e) => {
    e.preventDefault();
    // if (this.validateuploadpathForm()) {
    var formData = new FormData();
    formData.append("chpiId", this.state.chpiId);
    formData.append("proposalId", this.state.proposalId);
    formData.append("ovdType", this.state.ovdType);
    formData.append("filePath", this.state.filePath);
    console.log(this.state.dob);
    console.log(this.state.aadharno);
    fetch(configData.api_url + "leads/ovdkyc", {
      // Enter your IP address here

      method: "POST",
      //headers :{ 'Content-Type' : 'application/json'},
      mode: "cors",
      body: formData, // body data type must match "Content-Type" header
    })
      .then((response) => response.json())
      .then((data) => {
        this.showToast(data.message, data.success);
        if (data.status === "success") {
          //this.createPolicy();
          this.setState({
            dob: "",
            idTYPE: "",
            aadharno: "",
            gender: "",
            name: "",
          });
          //window.location.href = "/proposerinfo";
        } else {
          this.setState({ showUploadform: true });
        }
      });
    //}
  };
  handleFileidentitiuploadSubmitClick = (e) => {
    e.preventDefault();
    // if (this.validateuploadpathForm()) {
    var formData = new FormData();
    formData.append("chpiId", this.state.chpiId);
    formData.append("proposalId", this.state.proposalId);
    formData.append("ovdType", this.state.ovdType);
    formData.append("filePath", this.state.filePath);
    console.log(this.state.dob);
    console.log(this.state.aadharno);
    fetch(configData.api_url + "leads/ovdkyc", {
      // Enter your IP address here

      method: "POST",
      //headers :{ 'Content-Type' : 'application/json'},
      mode: "cors",
      body: formData, // body data type must match "Content-Type" header
    })
      .then((response) => response.json())
      .then((data) => {
        this.showToast(data.message, data.success);
        if (data.status === "success") {
          this.handleButtonClick();
          this.setState({
            dob: "",
            idTYPE: "",
            aadharno: "",
            gender: "",
            name: "",
          });
          //window.location.href = "/proposerinfo";
        } else {
          this.setState({ showUploadform: true });
        }
      });
    //}
  };
  handleButtonClick = () => {
    const proposalNum = sessionStorage.getItem("proposalNum");
    window.location.href =
      configData.api_url +
      "payments?origin=" +
      window.location.origin +
      "&proposalNum=" +
      proposalNum +
      "&proposalId=" +
      this.state.proposalId;
    // window.location.href = "/payments/";
  };
  onKeyDown = (event) => {
    if (event.key === " ") {
      event.preventDefault();
      toast.error("Spaces are not allowed.");
    }
  };
  handleNoPANClick = () => {
    // Function to handle click on "I don't have PAN card"
    this.setState({
      noPanCard: true,
      idTYPE: "ADHAR", // Set default ID type to Aadhar
      showAadharForm: true,
    });
  };
  handleNoUPLOAdClick = () => {
    this.setState({
      noPanCard: true,
      idTYPE: "VoterID",
      showUploadform: true,
    });
  };
  handleaddrssChange = (e) => {
    e.preventDefault();
    const fieldValue = e.target.value;
    this.setState({ ovdType: fieldValue });
  };
  handleaddrssoneChange = (e) => {
    e.preventDefault();
    const fieldValue = e.target.value;
    this.setState({ ovdType: fieldValue });
  };
  handleaddressuploadChange = (e) => {
    e.preventDefault();
    // const fieldValue = e.target.value;
    // this.setState({ policyupload: fieldValue });
    const files = e.target.files[0];
    this.setState({ filePath: files });
  };
  handleIdentityuploadChange = (e) => {
    e.preventDefault();
    // const fieldValue = e.target.value;
    // this.setState({ policyupload: fieldValue });
    const files = e.target.files[0];
    this.setState({ filePath: files });
  };
  render() {
    const previousYearStart = new Date();
    previousYearStart.setFullYear(previousYearStart.getFullYear() - 100);
    previousYearStart.setMonth(0); // Set the month to January
    previousYearStart.setDate(1); // Set the date to the first day of January

    // Example end year
    const endYear = new Date();
    endYear.setFullYear(endYear.getFullYear() + 10);
    return (
      <div>
        <LoadingOverlay show={this.state.loading} message={this.state.loadingMessage} />
        <h3 className="logoskybluecolor">PoliciesKYCForm Page</h3>
        <Container className="bgalphacolor">
          <Card>
            <Card.Body>
              <div className="row">
                <div className="col-md-4">
                  <label for="exampleFormControlInput1" className="form-label">
                    Identity Proof:
                  </label>
                  <Form.Select
                    name="idTYPE"
                    value={this.state.idTYPE}
                    onChange={this.handleChange}
                    aria-label="Default select example"
                    className="form-control"
                    id="idTYPE"
                    disabled={this.state.showAadharForm}
                  >
                    <option selected>select Identity Type</option>
                    <option value="PAN">PAN</option>
                  </Form.Select>
                </div>
                <div className="col-md-4">
                  <label htmlFor="idNum" className="form-label">
                    PAN No:
                  </label>
                  <input
                    type="text"
                    name="idNum"
                    value={this.state.idNum}
                    className="form-control"
                    id="idNum"
                    placeholder="Enter PAN Number"
                    onChange={this.handleChange}
                    disabled={this.state.showAadharForm}
                  />
                  <Link id="noPANBtn" onClick={this.handleNoPANClick}>
                    I don't have PAN card
                  </Link>
                </div>

                <div className="col-md-4">
                  <label htmlFor="dob" className="form-label">
                    DOB:
                  </label>

                  <div calendarClassName="custom-calendar">
                    <DatePicker
                      dropdownMode="select"
                      dateFormat="dd/MM/yyyy"
                      showTimeSelect={false}
                      selected={this.state.dob}
                      onChange={(date) => this.handleDChange(date)}
                      className="form-control"
                      id="dob"
                      placeholderText="Select Date of Birth"
                      peekNextMonth
                      showMonthDropdown
                      showYearDropdown
                      minDate={previousYearStart} // Set the minimum selectable date
                      maxDate={endYear} // Set the maximum selectable date
                      disabled={this.state.showAadharForm}
                    />
                  </div>
                </div>
              </div>
              <br />
              <Row className="justify-content-between">
                <Col lg="12" md="12">
                  {/* <Button
                              style={{ float: 'left',color:"#fff",backgroundColor:"#0069d9","borderColor":"#00062cc"}}
                              onClick={this.handleAddClick}  
                            >
                              Add
                            </Button> */}
                  <Button
                    id="getQuotes4"
                    type="submit"
                    onClick={this.handleSubmitClick}
                    style={{ float: "right" }}
                    disabled={this.state.showAadharForm}
                  >
                    Submit{" "}
                  </Button>
                </Col>
              </Row>
            </Card.Body>
          </Card>
          <br />
          {this.state.showAadharForm && (
            <Card>
              <Card.Body>
                <div className="text-center">Aadhar Verification</div>
                <div className="row">
                  <div className="col-md-4">
                    <label
                      for="exampleFormControlInput1"
                      className="form-label"
                    >
                      Identity Proof:
                    </label>
                    <Form.Select
                      name="idTYPE"
                      value={this.state.idTYPE}
                      aria-label="Default select example"
                      className="form-control"
                      id="idTYPE"
                      onChange={this.handleChange}
                      disabled={this.state.showUploadform}
                    >
                      <option selected>select Identity Type</option>
                      <option value="AADHAR">AADHAR</option>
                    </Form.Select>
                  </div>
                  <div className="col-md-4">
                    <label htmlFor="idNum" className="form-label">
                      Aadhar Card No:
                    </label>
                    <input
                      onKeyDown={this.onKeyDown}
                      type="text"
                      name="aadharno"
                      value={this.state.aadharno}
                      className="form-control"
                      id="aadharno"
                      placeholder="Enter last 4 digit Aadhar Number"
                      onChange={this.handleChange}
                      maxLength={4}
                      disabled={this.state.showUploadform}
                    />
                    <Link id="noPANBtn" onClick={this.handleNoUPLOAdClick}>
                      I don't have AADHAR card
                    </Link>
                  </div>
                  <div className="col-md-4">
                    <label htmlFor="dob" className="form-label">
                      NAME:
                    </label>
                    <input
                      type="text"
                      name="name"
                      value={this.state.name}
                      className="form-control"
                      id="name"
                      placeholder="Enter Name"
                      onChange={this.handleChange}
                      disabled={this.state.showUploadform}
                    />
                  </div>

                  <div className="col-md-4">
                    <label htmlFor="dob" className="form-label">
                      Gender:
                    </label>
                    <Form.Select
                      name="gender"
                      value={this.state.gender}
                      onChange={this.handleChange}
                      aria-label="Default select example"
                      className="form-control"
                      id="gender"
                      disabled={this.state.showUploadform}
                    >
                      <option selected>select</option>
                      <option value="M">Male</option>
                      <option value="F">Female</option>
                      <option value="O">Other</option>
                    </Form.Select>
                  </div>
                  <div className="col-md-2">
                    <label htmlFor="dob" className="form-label">
                      DOB:
                    </label>

                    <div calendarClassName="custom-calendar">
                      <DatePicker
                        dropdownMode="select"
                        dateFormat="dd/MM/yyyy"
                        showTimeSelect={false}
                        selected={this.state.dob}
                        onChange={(date) => this.handleDChange(date)}
                        className="form-control policiesdatepicker"
                        id="dob"
                        placeholderText="Select Date of Birth"
                        peekNextMonth
                        showMonthDropdown
                        showYearDropdown
                        minDate={previousYearStart} // Set the minimum selectable date
                        maxDate={endYear}
                        popperClassName="date-picker-reports"
                        disabled={this.state.showUploadform}
                      />
                    </div>
                  </div>
                </div>
                <br />
                <Row className="justify-content-between">
                  <Col lg="12" md="12">
                    {/* <Button
                              style={{ float: 'left',color:"#fff",backgroundColor:"#0069d9","borderColor":"#00062cc"}}
                              onClick={this.handleAddClick}  
                            >
                              Add
                            </Button> */}
                    <Button
                      id="getQuotes4"
                      type="submit"
                      onClick={this.handleAadhaarSubmitClick}
                      style={{ float: "right" }}
                      disabled={this.state.showUploadform}
                    >
                      Submit{" "}
                    </Button>
                  </Col>
                </Row>
              </Card.Body>
            </Card>
          )}
          <br />
          {this.state.showUploadform && (
            <Card>
              <Card.Body>
                <div className="text-center">Document Verification</div>
                <div className="row">
                  <div className="col-md-4">
                    <label
                      for="exampleFormControlInput1"
                      className="form-label"
                    >
                      Address Proof:
                    </label>
                    <Form.Select
                      name="idTYPE"
                      value={this.state.idTYPE}
                      aria-label="Default select example"
                      className="form-control"
                      id="idTYPE"
                      onChange={this.handleChange}
                    >
                      <option selected>select Address Type</option>
                      <option value="PAN">PAN</option>
                      <option value="Voter ID">Voter ID</option>
                      <option value="Driving Licence">Driving Licence</option>
                      <option value="Passport">Passport</option>
                    </Form.Select>
                  </div>
                  <div className="col-md-4">
                    <label
                      for="exampleFormControlInput1"
                      className="form-label"
                    >
                      Address Type:
                    </label>
                    <Form.Select
                      name="ovdType"
                      value={this.state.ovdType}
                      aria-label="Default select example"
                      className="form-control"
                      id="ovdType"
                      onChange={this.handleaddrssoneChange}
                    >
                      <option selected>select Address Type</option>
                      <option value="Address Proof">Address Proof</option>
                    </Form.Select>
                  </div>
                  <div className="col-md-4">
                    <label htmlFor="idNum" className="form-label">
                      File Uploader:
                    </label>
                    <input
                      // onKeyDown={this.onKeyDown}
                      type="file"
                      name="filePath"
                      //value={this.state.filePath}
                      className="form-control"
                      id="filePath"
                      placeholder=""
                      onChange={this.handleaddressuploadChange}
                    />
                  </div>
                </div>
                <br />
                <Row className="justify-content-between">
                  <Col lg="12" md="12">
                    {/* <Button
                              style={{ float: 'left',color:"#fff",backgroundColor:"#0069d9","borderColor":"#00062cc"}}
                              onClick={this.handleAddClick}  
                            >
                              Add
                            </Button> */}
                    <Button
                      id="getQuotes4"
                      type="submit"
                      onClick={this.handleFileuploadSubmitClick}
                      style={{ float: "right" }}
                      // disabled={this.state.showUploadform}
                    >
                      Submit{" "}
                    </Button>
                  </Col>
                </Row>
                <br />
                <div className="row">
                  <div className="col-md-4">
                    <label
                      for="exampleFormControlInput1"
                      className="form-label"
                    >
                      Identity Proof:
                    </label>
                    <Form.Select
                      name="idTYPE"
                      value={this.state.idTYPE}
                      aria-label="Default select example"
                      className="form-control"
                      id="idTYPE"
                      onChange={this.handleChange}
                    >
                      <option selected>select Identity Type</option>
                      <option value="Voter ID">Voter ID</option>
                      <option value="Driving Licence">Driving Licence</option>
                      <option value="Passport">Passport</option>
                    </Form.Select>
                  </div>
                  <div className="col-md-4">
                    <label
                      for="exampleFormControlInput1"
                      className="form-label"
                    >
                      Identity Type:
                    </label>
                    <Form.Select
                      name="ovdType"
                      value={this.state.ovdType}
                      aria-label="Default select example"
                      className="form-control"
                      id="ovdType"
                      onChange={this.handleaddrssChange}
                    >
                      <option selected>select Identity Type</option>
                      <option value="Identity Proof">Identity Proof</option>
                    </Form.Select>
                  </div>
                  <div className="col-md-4">
                    <label htmlFor="idNum" className="form-label">
                      File Uploader:
                    </label>
                    <input
                      // onKeyDown={this.onKeyDown}
                      type="file"
                      name="filePath"
                      //value={this.state.filePath}
                      className="form-control"
                      id="filePath"
                      placeholder=""
                      onChange={this.handleIdentityuploadChange}
                    />
                  </div>
                </div>
                <br />
                <Row className="justify-content-between">
                  <Col lg="12" md="12">
                    {/* <Button
                              style={{ float: 'left',color:"#fff",backgroundColor:"#0069d9","borderColor":"#00062cc"}}
                              onClick={this.handleAddClick}  
                            >
                              Add
                            </Button> */}
                    <Button
                      id="getQuotes4"
                      type="submit"
                      onClick={this.handleFileidentitiuploadSubmitClick}
                      style={{ float: "right" }}
                      // disabled={this.state.showUploadform}
                    >
                      Submit{" "}
                    </Button>
                  </Col>
                </Row>
              </Card.Body>
            </Card>
          )}
        </Container>
      </div>
    );
  }
}
